import React from "react";
import { useGoogleLogin } from "@react-oauth/google";
import '../App.css';
import './LoginPage.css';
import { googleAuth } from "../api";
import { useNavigate } from "react-router-dom";
import GoogleIcon from '../images/google-logo.svg';

function GoogleLogin(params) {
    const navigate = useNavigate();

   

        
      const responseGoogle = async (authResult) =>{
        try {
            if (authResult['code']){
                const result = await googleAuth(authResult['code']);

           


                // if result.data.user{
                  const {email, name} = result.data.user;
                  const token = result.data.token;
             
                  const obj = {token, email, name};
                  localStorage.setItem("user-info", JSON.stringify(obj));
              

                navigate('/');
            }
            console.log(authResult);
        } catch (error) {
            console.log("Error while request : ", error);
        }
      }

      const googleLogin = useGoogleLogin({
          onSuccess: responseGoogle,
          onError: responseGoogle,
          flow: 'auth-code'
      })



    return (
        <div className="social-login">
            {/* <button
                onClick={googleLogin}
            >
                Login with Google
            </button> */}
           
            <button onClick={googleLogin} className="social-btn google">
                <img src={GoogleIcon} alt="Google" className="icon" />
                Continue with Google
            </button>
        </div>
    )
}


export default GoogleLogin;